<div class="dash-content">
  <div class="dash-main-content">

    <!-- Titre & actions — toujours visibles -->
    <div class="dash-top">
      <h2 class="dash-title">Journalisation</h2>

      <div class="dash-action">
        <!-- Conteneur des filtres avec état désactivé pendant le chargement -->
        <div class="dash-action-left" [class.controls-disabled]="isLoading">
          <div class="select-wrapper">
            <select (change)="filterByEventType($event)" [disabled]="isLoading">
              <option value="" selected disabled>Tous les événements</option>
              @for (eventType of eventTypesList; track eventType) {
                <option [value]="eventType">
                  {{ getEventLabel(eventType) }}
                </option>
              }
            </select>
          </div>

          <div class="select-wrapper">
            <select (change)="filterByUser($event)" [disabled]="isLoading">
              <option value="" selected disabled>Tous les utilisateurs</option>
              @for (user of usersList; track user) {
                <option [value]="user.id">
                  {{ user?.firstName }} {{ user?.lastName }} ({{ user?.email }})
                </option>
              }
            </select>
          </div>

          <div class="select-wrapper">
            <select [(ngModel)]="selectedPeriod" (change)="onPeriodChange()" [disabled]="isLoading">
              <option value="">Toute la période</option>
              <option value="today">Aujourd'hui</option>
              <option value="week">Cette semaine</option>
              <option value="month">Ce mois</option>
              <option value="calendar">Choisir une date</option>
            </select>
          </div>

          <button class="button button-icon primary" (click)="loadLogings()" [disabled]="isLoading">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.5 17.5L22 22" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11Z" stroke="white" stroke-width="1.5" stroke-linejoin="round"/>
            </svg>
            <span>Recherche</span>
          </button>
        </div>

        <div class="dash-action-right">
          <!-- Actions supplémentaires si besoin -->
        </div>
      </div>
    </div>

    <!-- Tableau -->
    <table class="table">
      <thead>
        <tr>
          <th>Date</th>
          <!-- <th>IP</th> -->
          <th>Adresse mail</th>
          <th>Utilisateur</th>
          <th>Pseudo</th>
          <th>Application</th>
          <th>Action</th>
        </tr>
        <!-- Barre de progression sous l'en-tête pendant le chargement -->
        @if (isLoading) {
          <tr class="table-loading-row">
            <td colspan="7">
              <div class="table-progress-bar">
                <div class="table-progress-bar-inner"></div>
              </div>
            </td>
          </tr>
        }
      </thead>

      <tbody>
        <!-- Skeleton rows pendant le chargement -->
        @if (isLoading) {
          @for (i of [1,2,3,4,5]; track i) {
            <tr class="skeleton-row">
              <td><span class="skeleton skeleton-text"></span></td>
              <!-- <td><span class="skeleton skeleton-text skeleton-text--wide"></span></td> -->
              <td><span class="skeleton skeleton-text skeleton-text--wide"></span></td>
              <td><span class="skeleton skeleton-text"></span></td>
              <td><span class="skeleton skeleton-text"></span></td>
              <td><span class="skeleton skeleton-badge"></span></td>
              <td><span class="skeleton skeleton-text"></span></td>
            </tr>
          }
        }

        <!-- Données chargées -->
        @if (!isLoading && filteredEvents.length > 0) {
          @for (event of paginatedEvents; track event) {
            <tr>
              <td>{{ formatDateTime(event.timestamp) }}</td>
              <!-- <td>{{ event.ipAddress }}</td> -->
              <td>{{ event.user.email || 'N/A' }}</td>
              <td>{{ event.user.firstName || 'N/A' }} {{ event.user.lastName || 'N/A' }}</td>
              <td>{{ event.user.username || 'N/A' }}</td>
              <td>
                <div [ngClass]="event.clientId === 'ine' ? 'badge purple' : (event.clientId === 'formation' ? 'badge info' : 'badge neutral')">
                  {{ event.clientId }}
                </div>
              </td>
              <td>{{ event.grantType }}</td>
            </tr>
          }
        }

        <!-- État vide (aucun événement) -->
        @if (!isLoading && filteredEvents.length === 0) {
          <tr>
            <td colspan="7" class="table-empty-state">
              <div class="table-empty-state-inner">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.5 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V7.5L14.5 2Z" stroke="#C4C8C8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 2V8H20" stroke="#C4C8C8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 15H15" stroke="#C4C8C8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 11H15" stroke="#C4C8C8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p class="table-empty-state-title">Aucun événement trouvé</p>
                <p class="table-empty-state-subtitle">Essayez de modifier vos critères de recherche ou de filtre.</p>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <!-- Pagination avec état désactivé pendant le chargement -->
    @if (!isLoading && totalPages > 1) {
      <div class="paginate" [class.controls-disabled]="isLoading">
        <a (click)="goToPreviousPage()" [class.disabled]="currentPage === 0 || isLoading" class="paginate-arrow left">
          <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path [attr.stroke]="(currentPage === 0 || isLoading) ? '#CCCCCC' : 'black'" d="M4.27 7.81L0.75 4.28L4.27 0.75" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
        <ul class="paginate-item">
          @for (page of getDisplayPages(); track page) {
            <li [class.is-active]="page === currentPage + 1" [class.dots]="page === '...'">
              @if (page !== '...') {
                <a (click)="!isLoading && goToPage(+page - 1)">{{ page }}</a>
              }
              @if (page === '...') {
                <span>...</span>
              }
            </li>
          }
        </ul>
        <a (click)="goToNextPage()" [class.disabled]="currentPage === totalPages - 1 || isLoading" class="paginate-arrow right">
          <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path [attr.stroke]="(currentPage === totalPages - 1 || isLoading) ? '#CCCCCC' : '#5E5E5E'" d="M0.75 7.81L4.27 4.28L0.75 0.75" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>
    }

  </div>
</div>